import { render, staticRenderFns } from "./SpinnerComponent.vue?vue&type=template&id=60fd7e68&scoped=true"
import script from "./SpinnerComponent.vue?vue&type=script&lang=js"
export * from "./SpinnerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd7e68",
  null
  
)

export default component.exports